<template>
    <div class="my_orders_wrapper">
        <div class="orders_tabs">
            <div
                :class="`tab_item ${currentTabIndex === index ? 'active' : ''}`"
                v-for="(item, index) in tabs"
                :key="index"
                @click="handleTabClick(index)"
            >{{ item }}</div>
        </div>
        <div class="orders_list">
            <OrderItem v-for="(item, index) in orderList" :key="index" />
        </div>
    </div>
</template>

<script>
import "./MyOrders.less";
import { getMyOrders } from "../../api/api";

import OrderItem from "../../components/OrderItem/OrderItem.vue";
export default {
    name: "MyOrders",
    data() {
        return {
            tabs: ["全部", "即将到期", "已到期"],
            currentTabIndex: 0,
            orderList: [1, 2, 3],
        };
    },
    components: {
        OrderItem,
    },
    async mounted() {
        const PDdata = await getMyOrders({
            appNo: "20180706044909781-1074747",
        });
        console.log(PDdata);
    },
    methods: {
        handleTabClick(index) {
            if (index === this.currentTabIndex) return;
            this.currentTabIndex = index;
        },
    },
};
</script>

<style>
</style>